import { createUseStyles } from 'react-jss';
import { ITheme } from '../../components/theme';

export const mainWrapper = {
  m: '32px 0',
};
export const mainHeader = {
  mb: '32px',
};
export const photoWrapper = {
  padding: '14px',
  borderRadius: '6px',
  border: '1px solid rgba(0, 0, 0, 0.2)',
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: 'repeat(auto-fit, 90px)',
  overflowY: 'auto',
  maxHeight: '141px',

  '&::-webkit-scrollbar': {
    width: '5px',
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#fff',
    borderRadius: '5px',

  },
  '&::-webkit-scrollbar-thumb': {
    background: '#D9D9D9',
    borderRadius: '5px',

  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
    borderRadius: '5px',
  },
};

export const opportunityBlock = {
  display: 'grid',
  gridTemplateColumns: '41% 56.2%',
  justifyContent: 'space-between',
  gap: '28px',
  marginBottom: '40px',
};

export const opportunityBlockPhoto = {
  display: 'grid',
  gridTemplateColumns: '41% 56.2068%',
  justifyContent: 'space-between',
  gap: '28px',
  marginBottom: '40px',
  padding: '40px 0',
  borderBottom: '1px solid #D2D4D7',
  borderTop: '1px solid #D2D4D7',
};

export const opportunityBtns = {
  display: 'flex',
  justifyContent: 'end',
  gap: '16px',
  paddingBottom: '50px',
};

type RuleNames =
  | 'mainBlock'
  | 'mainText'
  | 'img'
  | 'activeImg'
  | 'childTypography'
  | 'mainTypography';

const PREFIX = 'EditOpportunityContent';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      mainBlock: {
        width: '1160px',
        margin: '0 auto',
        '& .MuiTypography-h6': {
          color: theme.darkGreen,
          fontFamily: theme.helveticaNeueBold,
        },
        '& .MuiTableCell-root': {
          fontFamily: theme.helveticaNeue,
        },
        '& .MuiPaper-root': {
          fontFamily: theme.helveticaNeue,
        },
        '& .MuiOutlinedInput-root': {
          fontSize: 14,
          fontFamily: theme.helveticaNeue,
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid black',
            },
          },
        },
      },
      mainText: {
        fontSize: '24px',
        fontWeight: 500,
        padding: '40px',
      },
      mainTypography: {
        '& .MuiTypography-h6': {
          fontFamily: theme.caslonDoric,
          color: theme.darkGreen,
        },
      },
      childTypography: {
        display: 'flex',

        '& .MuiTypography-body1': {
          color: theme.lightGreen,
          fontWeight: 400,
          fontFamily: theme.helveticaNeue,
        },
        '& .MuiTypography-body2': {
          color: theme.green,
          fontWeight: 500,
          fontFamily: theme.helveticaNeue,
          fontSize: '16px',
          marginLeft: '4px',
        },
      },
      img: {
        borderRadius: '4px',
        padding: '2px',
        width: '90px',
        aspectRatio: '1/0.66',
        border: '1px solid transparent',
        transition: 'all 300ms ease',
        '&:hover': {
          border: '1px solid black',
          cursor: 'pointer',
        },
      },
      activeImg: {
        border: '1px solid black',
        cursor: 'pointer',
      },
    }
  ),
  { name: PREFIX },
);
